import { PaginationReq } from "./types";

export const DEFAULT_PAGINATION_REQ: PaginationReq = {
  keyword: "",
  page: 1,
  pageSize: 24,
  sort: { key: "", type: "" },
};

export const API_VERSION = {
  V0: "",
  V1: "/v1",
};

export const API_HEADER = {
  VERSION: "Version",
  USER_ID: "x-id-user",
  BU_ID: "x-id-bu",
  CORP_ID: "x-id-corp",
  LANGUAGE: "x-lang",
  NTA_NUMBER: "x-nta",
  BLOCK_404: "block-404",
};

export const API_QUERY_TYPE = {
  LIST: "list",
  INFINITE: "infinite",
} as const;
